/* t22-hubb.js — guidehubbens designer (a–d förslag 2026-10-08, k Kroppsdelar 2026-10-09, f Flikar 2026-10-09) (sections/t22-hubb.liquid), 2026-10-08.
   Läser guidedata ur <script data-t22h-data> och ritar vald design i [data-t22h-app].
   ?omrade=<nyckel> öppnar ett område; valet skrivs tillbaka i adressen så att Bakåt och delade länkar fungerar. */
(function () {
  var rot = document.querySelector('[data-t22h]');
  if (!rot) return;
  var app = rot.querySelector('[data-t22h-app]');
  var G;
  try { G = JSON.parse(document.querySelector('[data-t22h-data]').textContent); } catch (e) { return; }
  rot.classList.add('t22h--js');
  var design = rot.getAttribute('data-design');
  var h1 = rot.querySelector('[data-t22h-h1]'), ingress = rot.querySelector('[data-t22h-ingress]');
  var h1Hubb = h1.firstChild.nodeValue, ingressHubb = ingress ? ingress.textContent : '';
  var smula = rot.querySelector('[data-t22h-smula]');

  // Kroppsdelarna. g = vilka guider som hör dit (zon eller det äldre området), om = "om knät" i ingressen.
  var ZON = [
    { k: 'kna', n: 'Knä', om: 'knät' },
    { k: 'vad', n: 'Vad och underben', om: 'vaden och underbenet' },
    { k: 'lar', n: 'Lår', om: 'låret' },
    { k: 'fot', n: 'Fot och häl', om: 'foten och hälen' },
    { k: 'hoft', n: 'Höft och ljumske', om: 'höften och ljumsken' },
    { k: 'rygg', n: 'Rygg', om: 'ryggen' },
    { k: 'axel', n: 'Axel', om: 'axeln' },
    { k: 'armbage', n: 'Armbåge', om: 'armbågen' },
    { k: 'handled', n: 'Hand och handled', om: 'handen och handleden' },
    { k: 'allmant', n: 'Allmänt', om: 'träningsvärk och att börja träna igen' }
  ];
  // De äldre områdesnycklarna (menyer och kategorisidor länkar med dem) blir grupper av zoner.
  var GRUPP = { underben: { n: 'Underben och lår', om: 'underbenet och låret', z: ['vad', 'lar'] }, arm: { n: 'Arm, axel och hand', om: 'armen, axeln och handen', z: ['axel', 'armbage', 'handled'] } };
  var SPORT = { padel: 'Padel', lopning: 'Löpning' };
  function zon(k) { for (var i = 0; i < ZON.length; i++) if (ZON[i].k === k) return ZON[i]; return null; }
  function omrade(k) {
    if (!k) return null;
    if (GRUPP[k]) return { k: k, n: GRUPP[k].n, om: GRUPP[k].om, z: GRUPP[k].z };
    var z = zon(k); return z ? { k: k, n: z.n, om: z.om, z: [k] } : null;
  }
  // Inom ett område: padel och löpning först, sedan guidernas ordning.
  function sortera(lista) { return lista.map(function (g, i) { return [g.s !== 'alla' ? 0 : 1, i, g]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; }); }
  function iOmrade(o) { return sortera(G.filter(function (g) { return o.z.indexOf(g.z) > -1; })); }
  function iZon(k) { return sortera(G.filter(function (g) { return g.z === k; })); }
  function e(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function marken(g) {
    var m = [];
    if (g.a) m.push('<i class="t22h-m t22h-m--vard">Sök vård</i>');
    if (SPORT[g.s]) m.push('<i class="t22h-m">' + SPORT[g.s] + '</i>');
    return m.join('');
  }
  // srcset/sizes (mobilfixarna 2026-10-08): korten ca 75 % av mobilbredden, raderna små.
  function bild(g, cls) {
    if (!g.b) return '<span class="' + (cls || '') + ' t22h-tombild"></span>';
    var sz = cls === 't22h-rad__bild' ? '160px' : cls === 't22h-gk__bild' ? '(min-width: 1000px) 30vw, (min-width: 700px) 45vw, 110px' : '(min-width: 900px) 30vw, 75vw';
    return '<img class="' + (cls || '') + '" src="' + e(g.b) + '"' + (g.bs ? ' srcset="' + e(g.bs) + '" sizes="' + sz + '"' : '') + ' alt="" loading="lazy" width="800" height="600">';
  }
  function antal(n) { return n + (n === 1 ? ' guide' : ' guider'); }
  var pil = '<svg class="t22h-pil" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  // Rubrik, ingress, brödsmula och adress följer valt område.
  var hubbUrl = location.pathname + '?' + (function () { var q = new URLSearchParams(location.search); q.delete('omrade'); return q.toString(); })();
  function satt(o, push) {
    h1.firstChild.nodeValue = o ? o.n : h1Hubb;
    if (ingress) ingress.textContent = o ? (o.k === 'allmant' ? 'Guider om ' + o.om + '.' : antal(iOmrade(o).length) + ' om besvär i ' + o.om + '. Välj det som liknar ditt.') : ingressHubb;
    var sista = smula.lastElementChild;
    if (o) {
      sista.removeAttribute('aria-current');
      sista.innerHTML = '<a href="' + e(hubbUrl) + '" data-t22h-hem>' + e(h1Hubb) + '</a>';
      var li = document.createElement('li'); li.setAttribute('aria-current', 'page'); li.textContent = o.n;
      if (smula.children.length > 2) smula.removeChild(smula.lastElementChild);
      smula.appendChild(li);
    } else {
      if (smula.children.length > 2) smula.removeChild(smula.lastElementChild);
      smula.lastElementChild.setAttribute('aria-current', 'page'); smula.lastElementChild.textContent = h1Hubb;
    }
    var q = new URLSearchParams(location.search);
    if (o) q.set('omrade', o.k); else q.delete('omrade');
    var ny = location.pathname + '?' + q.toString();
    if (push) history.pushState({ omrade: o ? o.k : '' }, '', ny); else history.replaceState({ omrade: o ? o.k : '' }, '', ny);
  }
  function start() { return omrade(new URLSearchParams(location.search).get('omrade')); }
  rot.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-t22h-hem]');
    if (a) { ev.preventDefault(); visa(null, true); }
  });
  window.addEventListener('popstate', function () {
    var v = new URLSearchParams(location.search).get('sport'); kSport = KSPORT[v] ? v : '';
    visa(start(), false);
  });

  // Rader som återanvänds: bild, titel, en rad, märken.
  function rad(g, cls) {
    return '<a class="t22h-rad ' + (cls || '') + '" href="' + e(g.u) + '">' + bild(g, 't22h-rad__bild') +
      '<span class="t22h-rad__text"><b>' + e(g.t) + '</b><span>' + e(g.l) + '</span>' + (marken(g) ? '<span class="t22h-marken">' + marken(g) + '</span>' : '') + '</span>' + pil + '</a>';
  }

  /* ================= A  Kroppskartan ================= */
  // Punkterna i procent av figurens ruta (viewBox 0 0 200 440). s = etikettens sida.
  var PUNKT = {
    axel: [33, 19, 'v', 'Axel'], armbage: [23, 36.5, 'v', 'Armbåge'], handled: [18.5, 52, 'v', 'Handled'],
    rygg: [50, 36, 'h', 'Rygg'], hoft: [56, 46.5, 'h', 'Höft'], lar: [58, 57, 'h', 'Lår'], kna: [59, 68, 'h', 'Knä'],
    vad: [59.5, 79, 'h', 'Vad'], fot: [63, 93.5, 'h', 'Fot']
  };
  var FIGUR = '<svg class="t22h-figur" viewBox="0 0 200 440" aria-hidden="true"><g fill="#dedede" stroke="#dedede" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle cx="100" cy="36" r="22" stroke="none"/><rect x="91" y="54" width="18" height="18" rx="4" stroke="none"/>' +
    '<path d="M70 78 Q100 68 130 78 Q136 120 128 150 Q124 178 130 206 L70 206 Q76 178 72 150 Q64 120 70 78 Z" stroke-width="12"/>' +
    '<path d="M66 84 L46 160 L37 226" fill="none" stroke-width="17"/><path d="M134 84 L154 160 L163 226" fill="none" stroke-width="17"/>' +
    '<circle cx="36" cy="234" r="10" stroke="none"/><circle cx="164" cy="234" r="10" stroke="none"/>' +
    '<path d="M86 204 L83 300 L81 398" fill="none" stroke-width="27"/><path d="M114 204 L117 300 L119 398" fill="none" stroke-width="27"/>' +
    '<ellipse cx="76" cy="412" rx="16" ry="8" stroke="none"/><ellipse cx="124" cy="412" rx="16" ry="8" stroke="none"/></g></svg>';
  function ritaA(o) {
    var punkter = Object.keys(PUNKT).map(function (k) {
      var p = PUNKT[k], z = zon(k), n = iZon(k).length, vald = o && o.z.indexOf(k) > -1;
      return '<button type="button" class="t22h-punkt t22h-punkt--' + p[2] + '" style="left:' + p[0] + '%;top:' + p[1] + '%" data-zon="' + k + '" aria-pressed="' + !!vald + '" aria-label="' + e(z.n) + ', ' + antal(n) + '">' +
        '<span class="t22h-punkt__prick" aria-hidden="true"></span><span class="t22h-punkt__namn">' + e(p[3]) + ' <small>' + n + '</small></span></button>';
    }).join('');
    var lista;
    if (o) {
      var gl = iOmrade(o);
      lista = '<div class="t22h-a__huvud"><h2>' + (o.k === 'allmant' ? 'Allmänt' : antal(gl.length) + ' om ' + e(o.om)) + '</h2><button type="button" class="t22h-lanknapp" data-t22h-hem>Alla kroppsdelar</button></div>' +
        '<div class="t22h-rader">' + gl.map(function (g) { return rad(g, 't22h-rad--stor'); }).join('') + '</div>';
    } else {
      lista = '<h2 class="t22h-a__uppmaning">Peka där det gör ont<span class="t22h-p" aria-hidden="true"></span></h2><p class="t22h-dampad">Eller välj bland alla ' + G.length + ' guider:</p>' +
        ZON.map(function (z) {
          var gl = iZon(z.k); if (!gl.length) return '';
          return '<section class="t22h-a__grupp"><h3><button type="button" class="t22h-lanknapp" data-zon="' + z.k + '">' + e(z.n) + '</button> <small>' + gl.length + '</small></h3>' +
            '<ul>' + gl.map(function (g) { return '<li><a href="' + e(g.u) + '">' + e(g.t) + '</a>' + (marken(g) ? ' ' + marken(g) : '') + '</li>'; }).join('') + '</ul></section>';
        }).join('');
    }
    var allm = o && o.k === 'allmant';
    app.innerHTML = '<div class="t22h-a">' +
      '<div class="t22h-a__karta"><div class="t22h-a__figur">' + FIGUR + punkter + '</div>' +
      '<p class="t22h-a__allm"><button type="button" class="t22h-lanknapp" data-zon="allmant" aria-pressed="' + allm + '">Allmänt: träningsvärk och att börja träna igen</button></p></div>' +
      '<div class="t22h-a__lista" data-t22h-lista>' + lista + '</div></div>';
  }

  /* ================= B  Frågeguiden ================= */
  var bVald = null;
  function steg(n) {
    return '<div class="t22h-steg" aria-label="Steg ' + n + ' av 3"><span class="t22h-steg__text">Steg ' + n + ' av 3</span><span class="t22h-steg__bar">' +
      [1, 2, 3].map(function (i) { return '<i class="' + (i < n ? 'klar' : i === n ? 'nu' : '') + '"></i>'; }).join('') + '</span></div>';
  }
  function ritaB(o) {
    var h;
    if (!o) {
      bVald = null;
      h = steg(1) + '<h2 class="t22h-b__fraga">Var gör det ont?</h2>' +
        '<div class="t22h-b__omraden">' + ZON.filter(function (z) { return z.k !== 'allmant'; }).map(function (z) {
          var n = iZon(z.k).length;
          return '<button type="button" class="t22h-b__omr" data-zon="' + z.k + '"><b>' + e(z.n) + '</b><span>' + antal(n) + '</span>' + pil + '</button>';
        }).join('') + '</div>' +
        '<p class="t22h-b__annat"><button type="button" class="t22h-lanknapp" data-zon="allmant">Inget särskilt ställe? Träningsvärk och att börja träna igen</button></p>' +
        '<div class="t22h-b__sok"><p>Vet du vad besväret heter?</p>' + sokfalt('Sök, till exempel hälsporre') + '<div class="t22h-rader t22h-b__traffar" data-t22h-traffar></div></div>';
    } else if (!bVald) {
      var gl = iOmrade(o);
      h = steg(2) + '<p class="t22h-b__tillbaka"><button type="button" class="t22h-lanknapp" data-t22h-hem>Tillbaka</button></p>' +
        '<h2 class="t22h-b__fraga">Vilket stämmer bäst på dig?</h2>' +
        '<div class="t22h-b__val">' + gl.map(function (g) {
          return '<a class="t22h-b__alt" href="' + e(g.u) + '" data-guide="' + e(g.h) + '"><span class="t22h-b__ring" aria-hidden="true"></span><span><b>' + e(g.l) + '</b><small>' + e(g.t) + (marken(g) ? ' ' + marken(g) : '') + '</small></span></a>';
        }).join('') + '</div>' +
        '<p class="t22h-b__annat">Inget stämmer? <button type="button" class="t22h-lanknapp" data-t22h-hem>Välj en annan kroppsdel</button></p>';
    } else {
      var g = bVald;
      h = steg(3) + '<p class="t22h-b__tillbaka"><button type="button" class="t22h-lanknapp" data-t22h-tillbaka>Välj en annan beskrivning</button></p>' +
        '<article class="t22h-b__svar">' + bild(g, 't22h-b__bild') + '<div>' +
        '<p class="t22h-over">' + e(o.n) + (SPORT[g.s] ? ' · ' + SPORT[g.s] : '') + '</p><h2>' + e(g.t) + '<span class="t22h-p" aria-hidden="true"></span></h2>' +
        (g.a ? '<p class="t22h-b__vard"><b>Sök vård.</b> Läs guiden för när du ska söka vård direkt, eller ring 1177.</p>' : '') +
        '<span class="t22h-etikett">Kort svar</span><p class="t22h-b__kort">' + e(g.k) + '</p>' +
        '<a class="t22h-knapp" href="' + e(g.u) + '">Läs hela guiden ' + pil + '</a></div></article>';
    }
    app.innerHTML = '<div class="t22h-b">' + h + '</div>';
  }

  /* ================= C  Sporten först ================= */
  var cSport = 'alla';
  function kort(g, stor) {
    var z = zon(g.z);
    return '<a class="t22h-kort' + (stor ? ' t22h-kort--stor' : '') + '" href="' + e(g.u) + '">' + bild(g, 't22h-kort__bild') +
      '<span class="t22h-over">' + e(z ? z.n : '') + (g.a ? ' · <span class="t22h-vardtext">Sök vård</span>' : '') + '</span><b>' + e(g.t) + '</b><span class="t22h-kort__rad">' + e(g.l) + '</span></a>';
  }
  function ritaC(o) {
    var h = '';
    if (!o) {
      ['padel', 'lopning'].forEach(function (sp) {
        var gl = G.filter(function (g) { return g.s === sp; });
        h += '<section class="t22h-c__sport" id="' + sp + '"><div class="t22h-c__shuvud"><h2>' + (sp === 'padel' ? 'Spelar du padel?' : 'Springer du?') + '<span class="t22h-p" aria-hidden="true"></span></h2>' +
          '<p class="t22h-dampad">' + antal(gl.length) + ' om besvär som ofta hör ihop med ' + (sp === 'padel' ? 'padel' : 'löpning') + '.</p></div>' +
          '<div class="t22h-c__galleri t22h-c__galleri--' + gl.length + '" data-t22h-skroll>' + gl.map(function (g, i) { return kort(g, i === 0 && gl.length > 3); }).join('') + '</div></section>';
      });
      h += '<section class="t22h-c__index"><h2>Alla besvär efter kroppsdel<span class="t22h-p" aria-hidden="true"></span></h2><div class="t22h-c__kolumner">' +
        ZON.map(function (z) {
          var gl = iZon(z.k); if (!gl.length) return '';
          return '<div class="t22h-c__kol"><h3><button type="button" class="t22h-lanknapp" data-zon="' + z.k + '">' + e(z.n) + '</button></h3><ul>' +
            gl.map(function (g) { return '<li><a href="' + e(g.u) + '">' + e(g.t) + '</a></li>'; }).join('') + '</ul></div>';
        }).join('') + '</div></section>';
      h = '<nav class="t22h-c__hopp" aria-label="Hoppa till"><a href="#padel">Padel</a><a href="#lopning">Löpning</a><a href="#alla-omraden">Alla kroppsdelar</a></nav>' + h.replace('class="t22h-c__index"', 'class="t22h-c__index" id="alla-omraden"');
    } else {
      var gl = iOmrade(o);
      var sporter = ['padel', 'lopning'].filter(function (sp) { return gl.some(function (g) { return g.s === sp; }); });
      if (cSport !== 'alla' && sporter.indexOf(cSport) < 0) cSport = 'alla';
      if (sporter.length) h += '<div class="t22h-piller" role="group" aria-label="Sport">' + ['alla'].concat(sporter).map(function (sp) {
        return '<button type="button" class="t22h-pill" data-sport="' + sp + '" aria-pressed="' + (cSport === sp) + '">' + (sp === 'alla' ? 'Alla' : SPORT[sp]) + '</button>';
      }).join('') + '</div>';
      var vis = cSport === 'alla' ? gl : gl.filter(function (g) { return g.s === cSport; });
      var sportG = vis.filter(function (g) { return g.s !== 'alla'; }), ovr = vis.filter(function (g) { return g.s === 'alla'; });
      if (sportG.length) h += '<section class="t22h-c__del"><h2 class="t22h-c__dh">För dig som spelar padel eller springer</h2><div class="t22h-c__galleri t22h-c__galleri--' + Math.min(sportG.length, 3) + '">' + sportG.map(function (g, i) { return kort(g, i === 0 && sportG.length > 1); }).join('') + '</div></section>';
      if (ovr.length) h += '<section class="t22h-c__del"><h2 class="t22h-c__dh">' + (sportG.length ? 'Fler besvär i ' + e(o.om) : 'Besvär i ' + e(o.om)) + '</h2><div class="t22h-c__rutnat">' + ovr.map(function (g) { return kort(g, false); }).join('') + '</div></section>';
      h += '<p class="t22h-c__ovr"><button type="button" class="t22h-lanknapp" data-t22h-hem>Alla kroppsdelar</button></p>';
    }
    app.innerHTML = '<div class="t22h-c' + (o ? ' t22h-c--omr' : '') + '">' + h + '</div>';
    var forsta = app.querySelector('img');
    if (forsta) { forsta.loading = 'eager'; forsta.setAttribute('fetchpriority', 'high'); }
  }

  /* ================= D  Uppslagsverket ================= */
  var dFilter = 'alla', dVald = null;
  function sokfalt(ph) {
    return '<label class="t22h-sok"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>' +
      '<span class="t22-vh">Sök bland guiderna</span><input type="search" placeholder="' + e(ph) + '" autocomplete="off" data-t22h-sok></label>';
  }
  function traffar(t) { t = t.trim().toLowerCase(); return t ? G.filter(function (g) { return g.q.indexOf(t) > -1; }) : null; }
  function ritaD(o) {
    if (o) dFilter = o.k;
    var piller = [['alla', 'Alla'], ['padel', 'Padel'], ['lopning', 'Löpning']].concat(ZON.filter(function (z) { return iZon(z.k).length; }).map(function (z) { return [z.k, z.n]; }));
    if (GRUPP[dFilter]) piller.splice(3, 0, [dFilter, GRUPP[dFilter].n]);
    app.innerHTML = '<div class="t22h-d">' +
      '<div class="t22h-d__verktyg">' + sokfalt('Sök på besvär eller känsla, till exempel låser sig') +
      '<div class="t22h-d__pillrad"><div class="t22h-piller t22h-piller--skroll" role="group" aria-label="Filter" data-t22h-skroll>' + piller.map(function (p) {
        return '<button type="button" class="t22h-pill" data-filter="' + p[0] + '" aria-pressed="' + (dFilter === p[0]) + '">' + e(p[1]) + '</button>';
      }).join('') + '</div></div></div>' +
      '<p class="t22h-d__antal" data-t22h-antal aria-live="polite"></p>' +
      '<div class="t22h-d__delad"><div class="t22h-d__lista" data-t22h-dlista></div><aside class="t22h-d__forhands" data-t22h-forhands aria-live="polite"></aside></div></div>';
    dLista();
  }
  function dLista() {
    var sok = app.querySelector('[data-t22h-sok]'), t = sok ? sok.value : '';
    var gl = traffar(t);
    if (!gl) {
      if (dFilter === 'alla') gl = G.slice();
      else if (SPORT[dFilter]) gl = G.filter(function (g) { return g.s === dFilter; });
      else gl = iOmrade(omrade(dFilter));
    }
    gl = gl.slice().sort(function (a, b) { return a.t.localeCompare(b.t, 'sv'); });
    var bokstav = '', h = '';
    gl.forEach(function (g) {
      var b = g.t.charAt(0).toUpperCase();
      if (b !== bokstav) { h += '<h2 class="t22h-d__bokstav">' + b + '</h2>'; bokstav = b; }
      var z = zon(g.z);
      h += '<div class="t22h-d__post" data-guide="' + e(g.h) + '"><a class="t22h-d__lank" href="' + e(g.u) + '"><b>' + e(g.t) + '</b><span>' + e(g.l) + '</span></a>' +
        '<span class="t22h-d__meta">' + e(z ? z.n : '') + marken(g) + '</span>' +
        '<button type="button" class="t22h-d__mer" aria-expanded="false" data-t22h-mer><span class="t22-vh">Visa kort svar om ' + e(g.t) + '</span><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '<div class="t22h-d__inline" hidden><p>' + e(g.k) + '</p><a class="t22h-lank" href="' + e(g.u) + '">Läs hela guiden</a></div></div>';
    });
    app.querySelector('[data-t22h-dlista]').innerHTML = h || '<p class="t22h-tom">Ingen guide matchar. Prova ett annat ord, till exempel häl, knä eller rygg.</p>';
    app.querySelector('[data-t22h-antal]').textContent = gl.length + ' av ' + G.length + ' guider';
    dVald = gl[0] || null; dForhands();
  }
  function dForhands() {
    var f = app.querySelector('[data-t22h-forhands]'); if (!f) return;
    var g = dVald; if (!g) { f.innerHTML = ''; return; }
    [].forEach.call(app.querySelectorAll('.t22h-d__post'), function (p) { p.classList.toggle('vald', p.getAttribute('data-guide') === g.h); });
    var z = zon(g.z);
    f.innerHTML = bild(g, 't22h-d__bild') + '<p class="t22h-over">' + e(z ? z.n : '') + (SPORT[g.s] ? ' · ' + SPORT[g.s] : '') + '</p><h2>' + e(g.t) + '<span class="t22h-p" aria-hidden="true"></span></h2>' +
      (g.a ? '<p class="t22h-b__vard"><b>Sök vård.</b> Läs guiden för när du ska söka vård direkt, eller ring 1177.</p>' : '') +
      '<span class="t22h-etikett">Kort svar</span><p>' + e(g.k) + '</p><a class="t22h-knapp" href="' + e(g.u) + '">Läs hela guiden ' + pil + '</a>';
  }

  /* ================= K  Kroppsdelar (Sadams beslut 2026-10-09, Guidehubb 2 Byggnot) =================
     Kroppsdelarna är huvudkategorierna: brickor med anatomiteckning. Två sportval, Löpning och Padel, sorterar
     sportens guider först och döljer aldrig något. Valet står i adressen (?sport=lopning|padel) så att Bakåt håller. */
  var KSPORT = {
    lopning: { n: 'Löpning', f: 'Först för dig som springer', om: 'löpning', b: 'r' },
    padel: { n: 'Padel', f: 'Först för dig som spelar padel', om: 'padel', b: 'p' }
  };
  var kSport = (function () { var v = new URLSearchParams(location.search).get('sport'); return KSPORT[v] ? v : ''; })();
  var IKON = {};
  try { IKON = JSON.parse((document.querySelector('[data-t22h-ikoner]') || {}).textContent || '{}'); } catch (x) {}
  var KORDNING = ['axel', 'armbage', 'handled', 'rygg', 'hoft', 'lar', 'kna', 'vad', 'fot', 'allmant'];
  var KNAMN = { handled: 'Hand och handled', allmant: 'Allmänt' };
  function kNamn(k) { return KNAMN[k] || zon(k).n; }
  // Guidernas egen ordning (mallens), inte de äldre designernas sportsortering.
  function kZon(z) { return G.filter(function (g) { return g.z === z; }); }
  function kOmr(o) { return G.filter(function (g) { return o.z.indexOf(g.z) > -1; }); }
  function kHar(g, sp) { return !!(sp && g[KSPORT[sp].b]); }
  function kAntalSport(k) { return kSport ? kZon(k).filter(function (g) { return kHar(g, kSport); }).length : 0; }
  // Sportens guider först, sedan resten; inom varje del guidernas egen ordning. Inget filtreras bort.
  function kSortera(lista) {
    return lista.map(function (g, i) { return [kHar(g, kSport) ? 0 : 1, i, g]; })
      .sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; });
  }
  function kLank(k) { var q = new URLSearchParams(location.search); q.set('omrade', k); return location.pathname + '?' + q.toString(); }
  function kMarken(g) {
    var m = [];
    if (g.r && fUtan !== 'lopning') m.push('<i class="t22h-m' + (kSport === 'lopning' ? ' t22h-m--vald' : '') + '">Löpning</i>');
    if (g.p && fUtan !== 'padel') m.push('<i class="t22h-m' + (kSport === 'padel' ? ' t22h-m--vald' : '') + '">Padel</i>');
    if (g.a) m.push('<i class="t22h-m t22h-m--vard">Sök vård</i>');
    return m.length ? '<span class="t22h-marken">' + m.join('') + '</span>' : '';
  }
  function kKort(g, visaZon) {
    return '<a class="t22h-gk" href="' + e(g.u) + '">' + bild(g, 't22h-gk__bild') + '<span class="t22h-gk__text">' +
      (visaZon ? '<span class="t22h-over">' + e(kNamn(g.z)) + '</span>' : '') +
      '<b>' + e(g.t) + '</b><span class="t22h-gk__rad">' + e(g.l) + '</span>' + kMarken(g) + '</span></a>';
  }
  function kSportval() {
    return '<div class="t22h-k__sport"><p class="t22h-k__sportfraga" id="t22h-ksp">Springer du eller spelar du padel?</p>' +
      '<div class="t22h-piller" role="group" aria-labelledby="t22h-ksp">' + ['lopning', 'padel'].map(function (sp) {
        return '<button type="button" class="t22h-pill" data-ksport="' + (kSport === sp ? '' : sp) + '" aria-pressed="' + (kSport === sp) + '">' + KSPORT[sp].n + '</button>';
      }).join('') + '</div>' +
      '<p class="t22h-k__sportinfo" aria-live="polite">' + (kSport
        ? 'Guiderna som tar upp ' + KSPORT[kSport].om + ' ligger först. Alla andra finns kvar under. <button type="button" class="t22h-lanknapp" data-ksport="">Vanlig ordning</button>'
        : 'Välj din sport så hamnar dess guider först. Inget göms.') + '</p></div>';
  }
  function kBricka(k, liten) {
    var n = kZon(k).length, ns = kAntalSport(k);
    var bildH = IKON[k] ? '<img src="' + e(IKON[k]) + '" alt="" loading="lazy" width="480" height="480">'
      : '<span class="t22h-bricka__ord" aria-hidden="true">' + (liten ? '?' : 'Träningsvärk eller skada?') + '</span>';
    return '<a class="t22h-bricka' + (liten ? ' t22h-bricka--liten' : '') + (IKON[k] ? '' : ' t22h-bricka--ord') + '" href="' + e(kLank(k)) + '" data-zon="' + k + '">' +
      '<span class="t22h-bricka__bild">' + bildH + '</span><span class="t22h-bricka__text"><b>' + e(kNamn(k)) + '</b>' +
      '<span class="t22h-bricka__antal">' + (k === 'allmant' && !liten ? 'Träningsvärk och att börja igen' : antal(n)) + '</span>' +
      (ns ? '<i class="t22h-m t22h-m--vald">' + ns + ' om ' + KSPORT[kSport].om + '</i>' : '') + '</span></a>';
  }
  // Med en sport vald flyttas kroppsdelarna som har sportens guider först; ordningen i övrigt är uppifrån och ner.
  function kBrickor(utom, liten) {
    var ord = KORDNING.filter(function (k) { return k !== utom && kZon(k).length; });
    if (kSport) ord = ord.map(function (k, i) { return [kAntalSport(k) ? 0 : 1, i, k]; })
      .sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (x) { return x[2]; });
    return '<div class="t22h-k__brickor' + (liten ? ' t22h-k__brickor--liten' : '') + '">' + ord.map(function (k) { return kBricka(k, liten); }).join('') + '</div>';
  }
  function ritaK(o) {
    var h = kSportval();
    if (!o) {
      if (kSport) {
        var sg = G.filter(function (g) { return kHar(g, kSport); });
        h += '<section class="t22h-k__del t22h-k__forst"><h2 class="t22h-k__h2">' + KSPORT[kSport].f + '<span class="t22h-p" aria-hidden="true"></span></h2>' +
          '<p class="t22h-dampad">' + antal(sg.length) + ' som tar upp ' + KSPORT[kSport].om + '. Alla andra ligger kvar under, efter kroppsdel.</p>' +
          '<div class="t22h-k__kort">' + sg.map(function (g) { return kKort(g, true); }).join('') + '</div></section>';
      }
      h += '<section class="t22h-k__del"><h2 class="t22h-k__h2">Var gör det ont?<span class="t22h-p" aria-hidden="true"></span></h2>' + kBrickor('', false) + '</section>';
      h += '<section class="t22h-k__del t22h-k__index"><h2 class="t22h-k__h2">Alla ' + G.length + ' guider<span class="t22h-p" aria-hidden="true"></span></h2><div class="t22h-k__kolumner">' +
        KORDNING.map(function (k) {
          var gl = kSortera(kZon(k)); if (!gl.length) return '';
          return '<div class="t22h-k__kol"><h3><a class="t22h-lanknapp" href="' + e(kLank(k)) + '" data-zon="' + k + '">' + e(kNamn(k)) + '</a></h3><ul>' +
            gl.map(function (g) { return '<li' + (kHar(g, kSport) ? ' class="t22h-k__forsta"' : '') + '><a href="' + e(g.u) + '">' + e(g.t) + '</a></li>'; }).join('') + '</ul></div>';
        }).join('') + '</div></section>';
    } else {
      var gl = kSortera(kOmr(o));
      var forst = gl.filter(function (g) { return kHar(g, kSport); }), rest = gl.filter(function (g) { return !kHar(g, kSport); });
      if (kSport && forst.length && rest.length) {
        h += '<section class="t22h-k__del"><h2 class="t22h-k__dh">' + KSPORT[kSport].n + ' först</h2><div class="t22h-k__kort' + (forst.length === 1 ? ' t22h-k__kort--en' : '') + '">' + forst.map(function (g) { return kKort(g); }).join('') + '</div></section>' +
          '<section class="t22h-k__del"><h2 class="t22h-k__dh">Fler besvär i ' + e(o.om) + '</h2><div class="t22h-k__kort">' + rest.map(function (g) { return kKort(g); }).join('') + '</div></section>';
      } else {
        if (kSport && !forst.length && o.k !== 'allmant') h += '<p class="t22h-k__ingen">Ingen av guiderna om ' + e(o.om) + ' tar upp ' + KSPORT[kSport].om + ' särskilt. Här är alla.</p>';
        h += '<section class="t22h-k__del"><div class="t22h-k__kort">' + gl.map(function (g) { return kKort(g); }).join('') + '</div></section>';
      }
      h += '<section class="t22h-k__del t22h-k__andra"><h2 class="t22h-k__dh">Andra kroppsdelar</h2>' + kBrickor(o.z.length === 1 ? o.z[0] : '', true) +
        '<p class="t22h-k__tillbaka"><button type="button" class="t22h-lanknapp" data-t22h-hem>Alla kroppsdelar och guider</button></p></section>';
    }
    app.innerHTML = '<div class="t22h-k' + (o ? ' t22h-k--omr' : '') + (kSport ? ' t22h-k--sport' : '') + '">' + h + '</div>';
  }

  /* ================= F  Flikar (förslag 2026-10-09, Guidehubb Flikar Byggnot) =================
     Skadeguidernas flikrad (samma klasser och CSS ur t22-guide.css: .t22g-flikar, .t22g-flik, .t22g-panel, .t22g--flikar)
     med en flik per kroppsdel (Sadams beslut 2026-10-10); klick på en flik visar den kroppsdelens guider.
     Flik-logiken är guidens (t22-guide.liquid): aria-selected, tabIndex, dolda paneler, vänster/höger-pil runt,
     tillbaka upp till raden när man bytt längre ner. Vald flik i adressen (&flik=padel), kroppsdel i Kroppsdelar
     (&omrade=kna), kroppsdel i en sportflik (&del=axel). Listan Alla 32 guider står under panelerna i alla flikar. */
  var FFLIK = KORDNING.filter(function (k) { return kZon(k).length; }).map(function (k) { return { k: k, n: kNamn(k) }; });
  /* Kroppsdelssidorna (Byggnot Kroppsdelssidor 2026-10-29, Sadams ja samma dag): en flik med egen sida är en vanlig
     länk dit, med kort text, skadorna och alla produkter. Allmänt har ingen sida och öppnas som förut i panelen.
     Hubben öppnar utan vald flik; listan Alla guider står under raden. */
  var KSIDA = { axel: '/pages/ont-i-axeln', armbage: '/pages/ont-i-armbagen', handled: '/pages/ont-i-handleden', rygg: '/pages/ont-i-ryggen',
    hoft: '/pages/ont-i-hoften', lar: '/pages/ont-i-laret', kna: '/pages/ont-i-knat', vad: '/pages/ont-i-vaden', fot: '/pages/ont-i-foten' };
  var fUtan = '';
  var fRot = null, fBar = null, fFlikar = [], fPaneler = [];
  function fNr(k) { for (var i = 0; i < FFLIK.length; i++) if (FFLIK[i].k === k) return i; return -1; }
  function fHref(i) { return KSIDA[FFLIK[i].k] || fAdress({ n: i }); }
  function fLas() {
    var q = new URLSearchParams(location.search), k = q.get('flik') || q.get('omrade') || '';
    if (GRUPP[k]) k = GRUPP[k].z[0];
    return { n: fNr(k) };
  }
  function fAdress(st) {
    var q = new URLSearchParams(location.search);
    q.delete('flik'); q.delete('omrade'); q.delete('del'); q.delete('sport');
    if (st.n > 0) q.set('flik', FFLIK[st.n].k);
    var s = q.toString();
    return location.pathname + (s ? '?' + s : '');
  }
  function fSkriv(st, push) {
    var ny = fAdress(st);
    if (ny === location.pathname + location.search) return;
    if (push) history.pushState({ f: 1 }, '', ny); else history.replaceState({ f: 1 }, '', ny);
  }
  // Höjden på det fasta sidhuvudet (samma regel som guiden): bara om huvudet faktiskt följer med.
  function fHuvud() {
    var h = document.querySelector('.t22-huvud');
    if (!h) return 0;
    var p = getComputedStyle(h).position;
    if (p === 'fixed') return h.offsetHeight;
    if (p !== 'sticky') return 0;
    var c = h.parentElement;
    while (c && getComputedStyle(c).display === 'contents') c = c.parentElement;
    return c && c.offsetHeight - h.offsetHeight > 100 ? h.offsetHeight : 0;
  }
  function fSattHuvud() { if (fRot) fRot.style.setProperty('--t22g-hh', fHuvud() + 'px'); }
  function fPanel(n) {
    var k = FFLIK[n].k, gl = kZon(k), o = omrade(k);
    fPaneler[n].innerHTML = '<section class="t22h-k__del"><h2 class="t22h-k__h2">' + e(o.n) + '<span class="t22h-p" aria-hidden="true"></span></h2>' +
      '<p class="t22h-dampad t22h-f__rad">' + (k === 'allmant' ? 'Guider om ' + e(o.om) + '.' : antal(gl.length) + ' om besvär i ' + e(o.om) + '. Välj det som liknar ditt.') + '</p>' +
      '<div class="t22h-k__kort' + (gl.length === 1 ? ' t22h-k__kort--en' : '') + '">' + gl.map(function (g) { return kKort(g); }).join('') + '</div></section>';
  }
  function fIndex() {
    return '<section class="t22h-k__del t22h-k__index"><h2 class="t22h-k__h2">Alla ' + G.length + ' guider<span class="t22h-p" aria-hidden="true"></span></h2><div class="t22h-k__kolumner">' +
      FFLIK.map(function (x) {
        return '<div class="t22h-k__kol"><h3><a class="t22h-lanknapp" href="' + e(fHref(fNr(x.k))) + '" data-zon="' + x.k + '">' + e(x.n) + '</a></h3><ul>' +
          kZon(x.k).map(function (g) { return '<li><a href="' + e(g.u) + '">' + e(g.t) + '</a></li>'; }).join('') + '</ul></div>';
      }).join('') + '</div></section>';
  }
  function fValj(n, tyst) {
    // Ingen vald flik (n = -1): den första får tangentbordsfokus.
    fFlikar.forEach(function (f, i) { f.setAttribute('aria-selected', String(i === n)); f.tabIndex = i === (n < 0 ? 0 : n) ? 0 : -1; });
    fPaneler.forEach(function (p, i) { p.hidden = i !== n; });
    if (tyst || !fBar || n < 0) return;
    var top = fRot.getBoundingClientRect().top + window.scrollY + (parseFloat(getComputedStyle(fBar).marginTop) || 0) - fHuvud();
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }
  function ritaF() {
    kSport = '';
    var st = fLas();
    // Gamla adresser (&flik=kna, &omrade=kna) går till kroppsdelens egen sida.
    if (st.n > -1 && KSIDA[FFLIK[st.n].k]) { location.replace(KSIDA[FFLIK[st.n].k]); return; }
    if (!fRot) {
      app.innerHTML = '<div class="t22h-k t22h-f t22g--flikar" data-t22h-f>' +
        '<div class="t22g-flikar" role="tablist" aria-label="Kroppsdelar" data-t22g-flikar>' + FFLIK.map(function (x, i) {
          return '<a class="t22g-flik" href="' + e(fHref(i)) + '" role="tab" id="t22h-flik-' + x.k + '" aria-controls="t22h-panel-' + x.k + '" aria-selected="false" data-t22h-flik="' + i + '">' + e(x.n) + '</a>';
        }).join('') + '</div>' +
        FFLIK.map(function (x) { return '<div class="t22g-panel" id="t22h-panel-' + x.k + '" role="tabpanel" aria-labelledby="t22h-flik-' + x.k + '" tabindex="-1" hidden></div>'; }).join('') +
        fIndex() + '</div>';
      fRot = app.querySelector('[data-t22h-f]'); fBar = fRot.querySelector('[data-t22g-flikar]');
      fFlikar = [].slice.call(fRot.querySelectorAll('[data-t22h-flik]'));
      fPaneler = [].slice.call(fRot.querySelectorAll('.t22g-panel'));
      fSattHuvud(); window.addEventListener('resize', fSattHuvud);
      fBar.addEventListener('keydown', function (ev) {
        var i = fFlikar.indexOf(document.activeElement);
        if (i < 0 || (ev.key !== 'ArrowRight' && ev.key !== 'ArrowLeft')) return;
        ev.preventDefault();
        var n = (i + (ev.key === 'ArrowRight' ? 1 : fFlikar.length - 1)) % fFlikar.length;
        fSkriv({ n: n }, false); fPanel(n); fValj(n, true); fFlikar[n].focus();
      });
    }
    if (st.n > -1) fPanel(st.n);
    fValj(st.n, true);
  }
  function fKlick(ev) {
    if (ev.ctrlKey || ev.metaKey || ev.shiftKey) return;
    var t = ev.target.closest('[data-t22h-flik]');
    var z = ev.target.closest('[data-zon]');
    var n = t ? +t.getAttribute('data-t22h-flik') : z ? fNr(z.getAttribute('data-zon')) : -1;
    if (n < 0) return;
    if (KSIDA[FFLIK[n].k]) return; // egen sida: länken går dit
    ev.preventDefault();
    if (n === fLas().n) { fValj(n); return; }
    fSkriv({ n: n }, true); fPanel(n); fValj(n);
  }

  /* ================= Gemensamt ================= */
  var RITA = { a: ritaA, b: ritaB, c: ritaC, d: ritaD, k: ritaK, f: ritaF };
  var nu = null;
  function visa(o, push) {
    if (design === 'f') { ritaF(); return; }
    nu = o; satt(o, push);
    if (design === 'b') bVald = null;
    (RITA[design] || ritaA)(o);
  }
  app.addEventListener('click', function (ev) {
    if (design === 'f') { fKlick(ev); return; }
    var z = ev.target.closest('[data-zon]');
    if (z) {
      ev.preventDefault(); visa(omrade(z.getAttribute('data-zon')), true);
      // På mobilen ligger listan under kartan: flytta dit.
      var l = app.querySelector('[data-t22h-lista]');
      if (l && design === 'a' && window.innerWidth < 900) l.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else if (design !== 'a') rot.scrollIntoView({ behavior: design === 'k' ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    var alt = ev.target.closest('.t22h-b__alt');
    if (alt && design === 'b') {
      ev.preventDefault();
      bVald = G.filter(function (g) { return g.h === alt.getAttribute('data-guide'); })[0];
      ritaB(nu); rot.scrollIntoView({ behavior: 'smooth', block: 'start' }); return;
    }
    if (ev.target.closest('[data-t22h-tillbaka]')) { bVald = null; ritaB(nu); return; }
    var ks = ev.target.closest('[data-ksport]');
    if (ks) {
      kSport = ks.getAttribute('data-ksport');
      var qs = new URLSearchParams(location.search); if (kSport) qs.set('sport', kSport); else qs.delete('sport');
      history.replaceState(history.state, '', location.pathname + '?' + qs.toString());
      ritaK(nu); return;
    }
    var sp = ev.target.closest('[data-sport]');
    if (sp) { cSport = sp.getAttribute('data-sport'); ritaC(nu); return; }
    var f = ev.target.closest('[data-filter]');
    if (f) {
      dFilter = f.getAttribute('data-filter');
      var s = app.querySelector('[data-t22h-sok]'); if (s) s.value = '';
      var o = SPORT[dFilter] || dFilter === 'alla' ? null : omrade(dFilter);
      nu = o; satt(o, true);
      [].forEach.call(app.querySelectorAll('[data-filter]'), function (b) { b.setAttribute('aria-pressed', String(b === f)); });
      dLista(); return;
    }
    var mer = ev.target.closest('[data-t22h-mer]');
    if (mer) {
      var post = mer.closest('.t22h-d__post'), ut = post.querySelector('.t22h-d__inline'), oppen = mer.getAttribute('aria-expanded') === 'true';
      mer.setAttribute('aria-expanded', String(!oppen)); ut.hidden = oppen;
      dVald = G.filter(function (g) { return g.h === post.getAttribute('data-guide'); })[0]; dForhands();
    }
  });
  // D: förhandsvisningen följer musen och tangentbordet på datorn.
  function folj(ev) {
    var p = ev.target.closest && ev.target.closest('.t22h-d__post');
    if (!p || design !== 'd') return;
    var g = G.filter(function (x) { return x.h === p.getAttribute('data-guide'); })[0];
    if (g && g !== dVald) { dVald = g; dForhands(); }
  }
  app.addEventListener('mouseover', folj); app.addEventListener('focusin', folj);
  app.addEventListener('input', function (ev) {
    if (!ev.target.matches('[data-t22h-sok]')) return;
    if (design === 'd') {
      if (ev.target.value.trim()) dFilter = 'alla';
      if (ev.target.value.trim()) [].forEach.call(app.querySelectorAll('[data-filter]'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === 'alla')); });
      dLista();
    } else {
      var gl = traffar(ev.target.value), ut = app.querySelector('[data-t22h-traffar]');
      if (ut) ut.innerHTML = gl ? (gl.length ? gl.map(function (g) { return rad(g); }).join('') : '<p class="t22h-tom">Ingen guide matchar. Prova ett annat ord, till exempel häl, knä eller rygg.</p>') : '';
    }
  });
  visa(start(), false);
})();
